import { Link } from 'react-router-dom';
import { APP_ROUTES } from '../../utils/constants/appRoutes';
import '../../pages/legal/legal.css';

interface LegalLinksProps {
  variant?: 'inline' | 'sidebar';
  /** Shorter labels for tight auth footers. Accessible names stay the full titles. */
  shortLabels?: boolean;
}

const LegalLinks = ({ variant = 'inline', shortLabels = false }: LegalLinksProps) => {
  const terms = (
    <Link to={APP_ROUTES.TERMS_OF_SERVICE} aria-label="Terms of Service">
      {shortLabels ? 'Terms' : 'Terms of Service'}
    </Link>
  );
  const privacy = (
    <Link to={APP_ROUTES.PRIVACY_POLICY} aria-label="Privacy Policy">
      {shortLabels ? 'Privacy' : 'Privacy Policy'}
    </Link>
  );

  if (variant === 'sidebar') {
    return (
      <nav className="sidebar-legal-links" aria-label="Legal">
        {terms}
        {privacy}
      </nav>
    );
  }

  return (
    <div className={`auth-nav-link legal-links${shortLabels ? ' legal-links--quiet' : ''}`}>
      {terms}
      <span aria-hidden="true"> · </span>
      {privacy}
    </div>
  );
};

export default LegalLinks;
